// The server owns this verified cache; native workflow timestamps remain intact.
export const activityEnabled = c =>
  c?.message_activity_enabled === true || c?.messageActivityEnabled === true;

export const activityTimestamp = c => {
  const value = activityEnabled(c)
    ? (c.message_activity_at ?? c.messageActivityAt)
    : (c?.last_activity_at ?? c?.lastActivityAt ?? c?.timestamp);
  return typeof value === 'number' && Number.isFinite(value) && value > 0
    ? value
    : null;
};

export const compareActivity = (a, b, direction) => {
  const x = activityTimestamp(a);
  const y = activityTimestamp(b);
  if (x === null && y !== null) return 1;
  if (y === null && x !== null) return -1;
  if (x !== y) return direction === 'asc' ? x - y : y - x;
  return (b.id || 0) - (a.id || 0);
};

export const mergeActivity = (target, source) => {
  if (!source || typeof source.message_activity_enabled !== 'boolean') return;
  const revision = source.message_activity_revision;
  if (!Number.isSafeInteger(revision) || revision < 0) return;
  if (revision < (target.message_activity_revision || 0)) return;
  target.message_activity_enabled = source.message_activity_enabled;
  target.message_activity_at = source.message_activity_at ?? null;
  target.message_activity_revision = revision;
};
